"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 上市公司综合回报指标
 */
var base_1 = __importDefault(require("./base"));
var confirm_1 = __importDefault(require("../../src/modules/confirm"));
init();
//主表配置
//loadtabledata();
//事件配置
loadevent();
function init() {
    if (document.cookie.match(new RegExp("(^| )zhhb_tip=1(;|$)"))) {
        //主表配置
        loadtabledata();
        return;
    }
    new confirm_1["default"]({
        mask: true,
        confirmText: '我已了解(5)',
        cancelText: '返回',
        title: "免责声明",
        height: '310',
        width: '450',
        content: "本页面所展示的综合回报排名系统的排名及相关指标系依据上市公司客观数据所得，仅为知识普及、投资者教育之目的，不构成对投资者的任何投资建议，不存在任何荐股行为，系统开发及提供方将不对投资者因使用该等指标而引发或可能引发的损失承担任何责任，请投资者理性使用！",
        confirm: function (e) {
            if ($('.confirm_foot .btn-confirm').hasClass('ylj')) {
                var exdate = new Date("2099/1/1");
                document.cookie = "zhhb_tip=1; path=/;expires=" + exdate.toUTCString();
                //主表配置
                loadtabledata();
                e.remove();
            }
        },
        cancel: function (e) {
            e.remove();
            location.href = document.referrer || '/';
        }
    });
    var djs = 5;
    var timerdjs = setInterval(function () {
        djs--;
        if (djs > 0) {
            $('.confirm_foot .btn-confirm').html("\u6211\u5DF2\u4E86\u89E3(" + djs + ")");
        }
        else {
            clearInterval(timerdjs);
            $('.confirm_foot .btn-confirm').html("\u6211\u5DF2\u4E86\u89E3").addClass('ylj');
        }
    }, 1000);
}
function loadevent() {
    $('.statement-img-box').on('click', function () {
        $(this).parent().toggleClass('expand');
    });
    $(document).on("mouseover", ".icon_faq", function (event) {
        var eleft = $(this).offset().left;
        var etop = $(this).offset().top;
        var wwidth = $(document).width();
        $(".tipbox").css({ 'left': eleft + 15, 'top': etop + 15, 'display': 'block', 'right': 'auto' }).html($(this).data("title"));
        if ($(document).width() < 450 + eleft)
            $(".tipbox").css({ 'right': wwidth - eleft, 'left': 'auto' });
    }).on("mouseout", ".icon_faq", function () {
        $(".tipbox").hide();
    });
    var ua = navigator.userAgent;
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    var isAndroid = ua.match(/(Android)\s+([\d.]+)/) && ua.match(/(Mobile)\s+/);
    var isMobile = isIphone || isAndroid;
    if (isMobile) {
        $(document).on("click", ".icon_faq", function (event) {
            var eleft = $(this).offset().left;
            var etop = $(this).offset().top;
            $(".tipbox").css({ 'left': eleft + 15, 'top': etop + 15, 'display': 'block' }).html($(this).data("title")).width(350);
            event.stopPropagation();
        }).on("click", function () {
            $(".tipbox").hide();
        });
    }
}
function loadtabledata() {
    var opt = {
        urlkeyvalues: {
            pagenumber: "pageIndex",
            pagesize: "pageSize",
            sortname: "sortName",
            sortorder: "sortType"
        },
        sortordervalues: { desc: 2, asc: 1 },
        dataurl: {
            url: 'https://roi.eastmoney.com/inverstorapi/query2/mainInfoGet',
            params: {
                topNum: 100
            }
        },
        datafield: "data",
        totalfield: "totalNum",
        //serversort: false,
        data: pagedata.list,
        //fixedleft: 10,
        //datatype:'json',
        sortname: "compreReturn",
        filteroptions: [{
                name: 'stockType',
                fieldname: 'mkt',
                filterselector: "#filter_mkt",
                filtersoptionselector: "li",
                selectedclass: "at",
                values: {
                    hsa: '3',
                    sha: '1',
                    sza: '0',
                    cyb: '5',
                    kcb: '9'
                }
                /*  ,
                 handle: function (item, that) {
                     if (item.value == "kcb") {
                         $("#dataview").hide()
                         $(".kcbtip").show()
                         // $("#dataview .dataview-body table tbody").html(`<tr class="no-records-found"><td colspan="19" class="kcbtip">考虑到科创板上市时间过短且科创板上市公司股价波动较大，暂不将科创板企业纳入综合回报排名系统</tr></td>`)
                         return false
                     }
                     else{
                         $(".kcbtip").hide()
                         $("#dataview").show()
                     }
                 } */
            },
            {
                name: 'industryName',
                fieldname: 'hy',
                filterselector: ".filter_hy",
                filtersoptionselector: "option",
            }],
        columns: base_1["default"].columns,
        onPreBody: function (data) {
        }
    };
    $("#dataview").emdataview(opt);
}
